import React from 'react'
// components
import RightSectionCell from './Cell'
// themes
import colors from 'themes/colors'
// icons
import AddCircle from '@mui/icons-material/AddCircle'
import RemoveCircle from '@mui/icons-material/RemoveCircle'
// views
import { ButtonsWrapper } from '../../views'
import { RightRow, RightRowsContainer, RightRowsWrapper } from './views'
// utils
import { v4 as uuid } from 'uuid'
// types
import { TMatrix } from '../../types'
import { RowCellValueChangeFn } from '../../index'

interface Props {
  matrix: TMatrix
  setData: React.Dispatch<React.SetStateAction<TMatrix>>
  disabled: boolean
  removeRow: () => void
  relatedDataKey: string
  leftRowsLength: number
  appetiteEnabled: boolean
  onCellValueChange: RowCellValueChangeFn
  onOptionsSelect: (id: string) => Promise<void>
}

const findActiveColumn = (section) => {
  let activeColumn = -1

  section.forEach((row) => {
    row.forEach((cell, cellIdx) => {
      if (cell.selected) {
        activeColumn = Math.max(activeColumn, cellIdx)
      }
    })
  })

  return activeColumn
}

const RightMatrixSection: React.FC<Props> = ({
  matrix,
  setData,
  disabled,
  removeRow,
  relatedDataKey,
  leftRowsLength,
  appetiteEnabled,
  ...rest
}) => {
  const addRow = () => {
    setData((prev) => {
      const newRow = new Array(leftRowsLength + 1).fill(null).map((_) => ({ id: uuid(), value: null }))

      return {
        ...prev,
        bRightSection: [...prev.bRightSection, newRow],
        [relatedDataKey]: prev[relatedDataKey].map((row) => {
          return [...row, { id: uuid(), value: null }]
        })
      }
    })
  }

  const activeColumn = findActiveColumn(matrix.topSection)

  return (
    <RightRowsContainer>
      <RightRowsWrapper appetiteEnabled={disabled && appetiteEnabled} activeColumn={activeColumn}>
        {matrix.bRightSection.map((row, idx) => (
          <RightRow key={idx}>
            {row.map(({ id, value }, cellIdx) => (
              <RightSectionCell
                key={id}
                idx={idx}
                cellId={id}
                value={value}
                cellIdx={cellIdx}
                setData={setData}
                disabled={disabled}
                options={matrix.options}
                // @ts-ignore
                selected={matrix.selectedOption}
                {...rest}
              />
            ))}
          </RightRow>
        ))}
      </RightRowsWrapper>

      {!disabled && (
        <ButtonsWrapper disabled={matrix.bRightSection.length === 1}>
          <RemoveCircle htmlColor={colors.blue500} onClick={removeRow} />
          <AddCircle htmlColor={colors.blue500} onClick={addRow} />
        </ButtonsWrapper>
      )}
    </RightRowsContainer>
  )
}

export default RightMatrixSection
